import { render, staticRenderFns } from "./DimmerDevice.vue?vue&type=template&id=bb1406a8&scoped=true"
import script from "./DimmerDevice.vue?vue&type=script&lang=js"
export * from "./DimmerDevice.vue?vue&type=script&lang=js"
import style0 from "./DimmerDevice.vue?vue&type=style&index=0&id=bb1406a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb1406a8",
  null
  
)

export default component.exports